import { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Grid,
  Hidden,
  LinearProgress,
  Stack,
  Tooltip,
  Button,
} from '@mui/material';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import { useHistory } from 'react-router';
import { Formik, validateYupSchema, yupToFormErrors } from 'formik';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { DatePicker } from '../../lib/formik/DatePicker';
import { useDispatch } from 'react-redux';
import { SubHeading } from '../investors/components';
import MFSelectField from '../../lib/formik/SelectField';
import { getFundManagersList, getTrustessList } from '../../redux-store/actions/userManagement';
import {
  addFund,
  addPlan,
  fundAccess,
  getPlanList,
  updateFund,
} from '../../redux-store/actions/funds';
import { Location } from 'history';
import {
  accessType,
  addFundPlanType,
  addHurdleRate,
  ClassPlanProps,
  FundProps,
} from '../../redux-store/types/funds';
import { addFundValidation, editFundValidation } from '../../utils/schema';
import {
  allowOnlyNumbers,
  checkIfApplicable,
  currencyConversion,
  isAccreditedInvestorApplicable,
} from '../../utils/utilityFunctions';
import {
  EXCLUDE_CLAUSE_MASTER,
  Enable_Performance_Fee,
  excludeClauseSubLabel,
  hurdleRateMaster,
  yesNoMaster,
  YesNoBooleanMaster,
} from '../../utils/constant';
import { DataTable } from '../DataTable';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { ConfirmationDialog } from '../commonComponents';
import AddIcon from '@mui/icons-material/Add';
import UseRadioGroup from '../../lib/formik/Radio';
import { DistributorListType, FundManager, Trustee } from '../../redux-store/types/api-types';
import { getDistributorsListForFilters } from '../../redux-store/actions';
import MFCheckbox from '../../lib/formik/Checkbox';
import { MultipleSelect } from '../../lib/formik/MultipleSelectField';
type updatedAddHurdleRate = addHurdleRate & {
  sno: number;
};
import {
  IS_STAMP_PAPER_SERIES_MASTER,
  CurrencyMaster,
  defaultCurrency,
} from '../../utils/constant';

const newHurdleRate: updatedAddHurdleRate = {
  id: null,
  planId: '',
  hurdleRate: '',
  performanceFee: 0,
  isActive: true,
  sno: 0,
};

type updatedAddFundPlanType = {
  hurdlerates: updatedAddHurdleRate[];
  isApplicableForDistributor: boolean;
} & addFundPlanType;

const initialValues: updatedAddFundPlanType = {
  schemeCode: '',
  schemeName: '',
  amcCode: '',
  bankName: '',
  bankBranch: '',
  ifscCode: '',
  bankAccountNumber: '',
  id: '',
  schemeId: null,
  planCode: '',
  planDescription: '',
  schemeNature: '',
  registrationNumber: '',
  schemeCategory: '',
  country: '',
  currency: defaultCurrency,
  transactionCurrency: defaultCurrency,
  schemeStartDate: `${new Date()}`,
  lockInPeriod: '',
  lockInExtension: '',
  inActive: true,
  faceValue: 0,
  fundAddress1: '',
  fundAddress2: '',
  fundAddress3: '',
  isActive: true,
  custodian: '',
  setupFee: 0,
  fundManagerId: null,
  trusteeId: null,
  minCommitmentAmount: null,
  maxCommitmentAmount: 0,
  minContributionPercentage: 0,
  managementFee: 0,
  operatingExpenses: null,
  placementCost: null,
  performanceFee: 0,
  hurdleRate: 0,
  tcLink: '',
  hurdlerates: [newHurdleRate],
  excludeClause: '',
  exitCharge: '',
  exitChargeApplicable: '',
  excludeClauseApplicableInPlan: '',
  distributorIds: null,
  isApplicableForDirect: false,
  isApplicableForDistributor: false,
  distMangementFee: '',
  distPerformanceFee: '',
  CVL_PWD: '',
  CVL_PASSCODE: '',
  CVL_USERNAME: '',
  CVL_APP_POS_CODE: '',
  CVL_ENABLE_NEW_API: null,
  CVL_JSON_AES_KEY: '',
  CVL_JSON_API_KEY: '',
  LEEGALITY_STAMP_SERIES: '',
  LEEGALITY_STAMP_SERIES_GROUP: '',
  LEEGALITY_STAMP_VALUE: null,
  LEEGALITY_USE_STAMP_SERIES: null,
  managementFeeCheck: false,
  managementFeeAfterCommitment: 0,
  accreditedInvestorApplicable: '',
  accreditedMinCommitmentAmount: null,
};

export default function AddFund({
  location,
}: {
  location: Location<{ fundId: number }>;
}): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [fundManager, setFundManager] = useState<any[]>([]);
  const [editField, setEditField] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const { fundId } = location.state || {};
  const [access, setAccess] = useState(false);
  const [trustee, setTrustee] = useState<any[]>([]);
  const [hurdleRateToDelete, setHurdleRateToDelete] = useState<{
    index: number;
  } | null>(null);
  const columns: any = [
    {
      header: 'Hurdle Rate(PA) / Hurdle Rate of Return',
      label: 'hurdleRate',
      renderEditDeleteCell: (row: updatedAddHurdleRate): JSX.Element => {
        return (
          <>
            <Stack
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
                display: 'inline-flex',
                width: 350,
                maxWidth: '100%',
                py: 1,
                '& .MuiFormControl-root': { width: '100%', m: 0 },
              }}>
              <MFTextField
                name={`hurdlerates.${row.sno}.hurdleRate`}
                placeholder="Enter hurdle rate/ Hurdle Rate of Return"
              />
            </Stack>
          </>
        );
      },
    },
    {
      header: 'Performance Fees(PA)/ Additional return',
      label: 'performanceFee',
      renderEditDeleteCell: (row: updatedAddHurdleRate): JSX.Element => {
        return (
          <Stack
            sx={{
              flexDirection: 'row',
              alignItems: 'center',
              display: 'inline-flex',
              width: 350,
              maxWidth: '100%',
              py: 1,
              '& .MuiFormControl-root': { width: '100%', m: 0 },
            }}>
            <MFTextField
              name={`hurdlerates.${row.sno}.performanceFee`}
              // label="Performance Fee"
              placeholder="Enter Performance Fee/ Additional return"
              type="number"
              onKeyDown={(e) => {
                allowOnlyNumbers(e);
              }}
              trimOnBlur={false}
            />
          </Stack>
        );
      },
    },
  ];
  const AccessViewOrEditCell = [
    {
      header: '',
      renderCell: (row: updatedAddHurdleRate): JSX.Element => {
        return (
          <>
            <Stack
              sx={{
                flexDirection: 'row',
                alignItems: 'center',
                display: 'inline-flex',
                maxWidth: '100%',
                py: 1.5,
                '& .MuiFormControl-root': { width: '100%', m: 0 },
              }}>
              <Tooltip title="Delete">
                <IconButton
                  sx={{
                    ':hover': {
                      bgcolor: '#F4FCFC',
                    },
                  }}
                  onClick={() => setHurdleRateToDelete({ index: row.sno })}>
                  <DeleteOutlineIcon color="error" fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
          </>
        );
      },
    },
  ];
  const [distributorList, setDistributorList] = useState<DistributorListType[]>([]);

  useEffect(() => {
    let isComponentAlive = true;
    (async function () {
      try {
        setLoading(true);
        const trusteeList = (await dispatch(
          getTrustessList({ isActive: true })
        )) as unknown as Trustee[];
        const fundManagerList = (await dispatch(
          getFundManagersList({ isActive: true })
        )) as unknown as FundManager[];
        const { fundSetupAccess } = (await dispatch(fundAccess())) as unknown as accessType;
        setAccess(fundSetupAccess);
        setFundManager(fundManagerList);
        setTrustee(trusteeList);
        const res = (await dispatch(
          getDistributorsListForFilters()
        )) as unknown as DistributorListType[];
        setDistributorList(res);

        if (fundId) {
          const GetFundDetail = (await dispatch(
            getPlanList(fundId.toString())
          )) as unknown as FundProps;
          const {
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            excludeClauseApplicableInPlan,
            CVL_PWD,
            CVL_PASSCODE,
            CVL_USERNAME,
            CVL_APP_POS_CODE,
            CVL_ENABLE_NEW_API = null,
            CVL_JSON_AES_KEY = '',
            CVL_JSON_API_KEY = '',
            LEEGALITY_STAMP_SERIES = '',
            LEEGALITY_STAMP_SERIES_GROUP = '',
            LEEGALITY_STAMP_VALUE = null,
            LEEGALITY_USE_STAMP_SERIES = null,
          } = GetFundDetail || {};

          setEditField({
            ...editField,
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            excludeClauseApplicableInPlan,
            CVL_PWD,
            CVL_PASSCODE,
            CVL_USERNAME,
            CVL_APP_POS_CODE,
            CVL_ENABLE_NEW_API,
            CVL_JSON_AES_KEY,
            CVL_JSON_API_KEY,
            LEEGALITY_STAMP_SERIES,
            LEEGALITY_STAMP_SERIES_GROUP,
            LEEGALITY_STAMP_VALUE,
            LEEGALITY_USE_STAMP_SERIES: LEEGALITY_USE_STAMP_SERIES || false,
          });
        }
        if (!isComponentAlive) return;
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
      } finally {
        if (isComponentAlive) {
          setLoading(false);
        }
      }
    })();
    return () => {
      isComponentAlive = false;
    };
  }, []);

  const onSubmit = async (values: updatedAddFundPlanType) => {
    try {
      const {
        schemeCode,
        schemeName,
        amcCode,
        bankName,
        bankBranch,
        ifscCode,
        bankAccountNumber,
        excludeClauseApplicableInPlan,
        CVL_PWD,
        CVL_PASSCODE,
        CVL_USERNAME,
        CVL_APP_POS_CODE,
        CVL_ENABLE_NEW_API,
        CVL_JSON_AES_KEY,
        CVL_JSON_API_KEY,
        LEEGALITY_STAMP_SERIES = '',
        LEEGALITY_STAMP_SERIES_GROUP = '',
        LEEGALITY_STAMP_VALUE = null,
        LEEGALITY_USE_STAMP_SERIES = null,
      } = values;

      const _CVL_ENABLE_NEW_API =
        CVL_ENABLE_NEW_API?.toString() === 'true'
          ? true
          : CVL_ENABLE_NEW_API?.toString() === 'false'
          ? false
          : null;
      const _CVL_JSON_AES_KEY = CVL_ENABLE_NEW_API?.toString() === 'true' ? CVL_JSON_AES_KEY : null;
      const _CVL_JSON_API_KEY = CVL_ENABLE_NEW_API?.toString() === 'true' ? CVL_JSON_API_KEY : null;

      const {
        planCode,
        planDescription,
        schemeNature,
        registrationNumber,
        schemeCategory,
        country,
        currency,
        schemeStartDate,
        lockInPeriod,
        lockInExtension,
        inActive,
        faceValue,
        fundAddress1,
        fundAddress2,
        fundAddress3,
        isActive,
        custodian,
        setupFee,
        minCommitmentAmount,
        maxCommitmentAmount,
        minContributionPercentage,
        managementFee,
        operatingExpenses,
        placementCost,
        hurdleRate,
        performanceFee,
        fundManagerId,
        trusteeId,
        tcLink,
        hurdlerates = [],
        excludeClause,
        exitCharge,
        exitChargeApplicable,
        distributorIds,
        isApplicableForDirect,
        distMangementFee,
        distPerformanceFee,
        managementFeeCheck,
        managementFeeAfterCommitment,
        transactionCurrency,
        accreditedInvestorApplicable,
        accreditedMinCommitmentAmount,
      } = values;
      if (fundId) {
        await dispatch(
          updateFund(fundId, {
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            excludeClauseApplicableInPlan,
            CVL_PWD,
            CVL_PASSCODE,
            CVL_USERNAME,
            CVL_APP_POS_CODE,
            CVL_ENABLE_NEW_API: _CVL_ENABLE_NEW_API,
            CVL_JSON_AES_KEY: _CVL_JSON_AES_KEY,
            CVL_JSON_API_KEY: _CVL_JSON_API_KEY,
            LEEGALITY_STAMP_SERIES,
            LEEGALITY_STAMP_SERIES_GROUP,
            LEEGALITY_STAMP_VALUE,
            LEEGALITY_USE_STAMP_SERIES:
              LEEGALITY_USE_STAMP_SERIES?.toString() === 'true' ? true : false,
          })
        );
      } else {
        const fundRes = (await dispatch(
          addFund({
            schemeCode,
            schemeName,
            amcCode,
            bankName,
            bankBranch,
            ifscCode,
            bankAccountNumber,
            excludeClauseApplicableInPlan,
            CVL_PWD,
            CVL_PASSCODE,
            CVL_USERNAME,
            CVL_APP_POS_CODE,
            CVL_ENABLE_NEW_API: _CVL_ENABLE_NEW_API,
            CVL_JSON_AES_KEY: _CVL_JSON_AES_KEY,
            CVL_JSON_API_KEY: _CVL_JSON_API_KEY,
            LEEGALITY_STAMP_SERIES,
            LEEGALITY_STAMP_SERIES_GROUP,
            LEEGALITY_STAMP_VALUE,
            LEEGALITY_USE_STAMP_SERIES:
              LEEGALITY_USE_STAMP_SERIES?.toString() === 'true' ? true : false,
          })
        )) as unknown as FundProps;

        await dispatch(
          addPlan({
            schemeId: fundRes.id,
            planCode,
            planDescription,
            schemeNature,
            registrationNumber,
            schemeCategory,
            country,
            currency,
            schemeStartDate,
            lockInPeriod,
            lockInExtension,
            fundManagerId,
            trusteeId,
            inActive,
            faceValue,
            fundAddress1,
            fundAddress2,
            fundAddress3,
            isActive,
            custodian,
            setupFee: setupFee ? setupFee : 0,
            minCommitmentAmount,
            maxCommitmentAmount,
            minContributionPercentage: minContributionPercentage ? minContributionPercentage : 0,
            managementFee: managementFee ? managementFee : 0,
            operatingExpenses:
              operatingExpenses || operatingExpenses === 0 ? operatingExpenses : null,
            placementCost: placementCost || placementCost === 0 ? placementCost : null,
            performanceFee: performanceFee ? performanceFee : 0,
            hurdleRate: hurdleRate ? hurdleRate : 0,
            tcLink,
            hurdlerates: hurdlerates.filter((obj) => obj.isActive),
            excludeClause,
            exitCharge: checkIfApplicable(exitChargeApplicable) ? exitCharge : '',
            exitChargeApplicable,
            distributorIds,
            isApplicableForDirect,
            distMangementFee,
            distPerformanceFee,
            managementFeeCheck,
            managementFeeAfterCommitment: managementFeeCheck ? managementFeeAfterCommitment : null,
            transactionCurrency,
            accreditedInvestorApplicable,
            accreditedMinCommitmentAmount: isAccreditedInvestorApplicable(
              accreditedInvestorApplicable
            )
              ? accreditedMinCommitmentAmount
              : null,
          }) as unknown as ClassPlanProps
        );
      }
      history.push(fundId ? 'fund-details' : 'fund-list', { fundId: fundId });
    } catch (e) {
      console.error((e as Error).message);
    }
  };

  return (
    <>
      <Formik
        initialValues={editField}
        onSubmit={onSubmit}
        enableReinitialize={true}
        validate={(values: updatedAddFundPlanType) => {
          try {
            validateYupSchema(
              values,
              fundId ? editFundValidation : addFundValidation(values.managementFeeCheck),
              true,
              values
            );
          } catch (e) {
            return yupToFormErrors(e);
          }
        }}
        // validationSchema={}
      >
        {({ handleSubmit, values, setValues }) => (
          <Box
            sx={{
              bgcolor: 'white',
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
              borderRadius: '10px',
              py: { xs: 2, sm: 5 },
              pl: { xs: 0, sm: 5 },
              mt: { xs: 2, sm: 5 },
            }}
            component="form"
            noValidate
            onSubmit={handleSubmit}>
            <Hidden smUp={true}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(fundId ? 'fund-details' : 'fund-list', { fundId: fundId })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    color: '#1C2D47',
                  }}>
                  Back
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  my: 2,
                  py: 2,
                  pl: { xs: 3, sm: 0 },
                  color: 'primary.main',
                  bgcolor: 'rgba(238, 244, 251, 0.5)',
                }}>
                <PersonOutlineOutlinedIcon fontSize="large" />
                <Typography
                  sx={{
                    fontSize: 20,
                    fontWeight: 600,
                    pl: 1,
                  }}>
                  Fund Setup
                </Typography>
              </Box>
            </Hidden>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Hidden only="xs">
                <IconButton
                  sx={{ height: 'fit-content', p: 0 }}
                  onClick={() =>
                    history.push(fundId ? 'fund-details' : 'fund-list', { fundId: fundId })
                  }>
                  <NavigateBeforeIcon fontSize="medium" sx={{ color: 'common.black' }} />
                </IconButton>
              </Hidden>
              <Typography
                sx={{
                  fontSize: 20,
                  fontWeight: 600,
                  color: '#1C2D47',
                  pl: { xs: 3, sm: 0 },
                }}>
                {fundId ? 'Edit Fund' : 'Add Fund'}
              </Typography>
            </Box>
            {loading ? (
              <LinearProgress sx={{ mt: 2 }} />
            ) : (
              <>
                <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                  <SubHeading
                    sx={{
                      color: 'common.blue',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                      ml: { xs: 3.5 },
                      // backgroundColor: 'red',
                    }}>
                    {'Fund Details(Scheme)'}
                  </SubHeading>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="schemeCode"
                      label="Scheme Code *"
                      placeholder="Enter Scheme Code"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="schemeName"
                      label="Scheme Name *"
                      placeholder="Enter Scheme Name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="amcCode" label="AMC Code" placeholder="Enter AMC Code" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="bankName" label="Bank Name" placeholder="Enter Bank Name" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="bankBranch"
                      label="Bank Branch"
                      placeholder="Enter Bank Branch"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="ifscCode" label="IFSC Code" placeholder="Enter IFSC Code" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="bankAccountNumber"
                      label="Bank Account Number"
                      placeholder="Enter Bank Account Number"
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{ '.MuiFormControl-root': { marginTop: '16px' } }}>
                    <UseRadioGroup
                      name={`excludeClauseApplicableInPlan`}
                      formLabel={`Exclude Clause Applicable *`}
                      items={Object.keys(yesNoMaster).map((item) => ({
                        label: yesNoMaster[item],
                        value: item,
                      }))}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="CVL_USERNAME"
                      label="CVL USERNAME *"
                      placeholder="Enter CVL USERNAME"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField name="CVL_PWD" label="CVL PWD *" placeholder="Enter CVL PWD" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="CVL_PASSCODE"
                      label="CVL PASSCODE *"
                      placeholder="Enter CVL PASSCODE"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="CVL_APP_POS_CODE"
                      label="CVL APP POS CODE *"
                      placeholder="Enter CVL APP POS CODE"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4} mt={2}>
                    <UseRadioGroup
                      formLabel="CVL ENABLE NEW API *"
                      name={`CVL_ENABLE_NEW_API`}
                      items={Object.keys(YesNoBooleanMaster).map((ele) => ({
                        label: YesNoBooleanMaster[ele],
                        value: ele,
                      }))}
                      value={values.CVL_ENABLE_NEW_API?.toString()}
                    />
                  </Grid>
                  {values.CVL_ENABLE_NEW_API?.toString() === 'true' && (
                    <>
                      <Grid item xs={12} sm={6} md={4}>
                        <MFTextField
                          name="CVL_JSON_AES_KEY"
                          label="CVL JSON AES KEY *"
                          placeholder="Enter CVL JSON AES KEY"
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <MFTextField
                          name="CVL_JSON_API_KEY"
                          label="CVL JSON API KEY *"
                          placeholder="Enter CVL JSON API KEY"
                        />
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="LEEGALITY_STAMP_SERIES"
                      label="Stamp Paper Series *"
                      placeholder="Enter Stamp Paper Series"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="LEEGALITY_STAMP_SERIES_GROUP"
                      label="Stamp Paper Group *"
                      placeholder="Enter Stamp Paper Group"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <MFTextField
                      name="LEEGALITY_STAMP_VALUE"
                      label="Stamp Paper Value *"
                      placeholder="Enter Stamp Paper Value"
                      type="number"
                      onKeyDown={(e) => {
                        allowOnlyNumbers(e);
                      }}
                      trimOnBlur={false}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}>
                    <UseRadioGroup
                      name={`LEEGALITY_USE_STAMP_SERIES`}
                      formLabel="Use Stamp Paper Series *"
                      items={Object.keys(IS_STAMP_PAPER_SERIES_MASTER).map((item) => ({
                        label: IS_STAMP_PAPER_SERIES_MASTER[item],
                        value: item,
                      }))}
                      value={values.LEEGALITY_USE_STAMP_SERIES?.toString()}
                    />
                  </Grid>
                </Grid>
                {!fundId && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <SubHeading
                      sx={{
                        color: 'common.blue',
                        letterSpacing: 0.5 + 'px',
                        padding: { xs: '10px 10px', sm: '10px 30px' },
                        ml: { xs: 3.5 },
                      }}>
                      {'Plan Details'}
                    </SubHeading>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="planCode"
                        label="Plan Code *"
                        placeholder="Enter Plan Code"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="planDescription"
                        label="Plan Description *"
                        placeholder="Enter Plan Description"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="schemeNature"
                        label="Scheme Nature *"
                        placeholder="Enter Scheme Nature"
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="registrationNumber"
                        label="Registration Number *"
                        placeholder="Enter Registration Number"
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="fundManagerId"
                        label="Investment Manager Name *"
                        items={fundManager.map((item) => ({
                          key: item.name,
                          value: item.id,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="trusteeId"
                        label="Trustee Name *"
                        items={trustee.map((item) => ({
                          key: item.name,
                          value: item.id,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="schemeCategory"
                        label="Scheme Category *"
                        placeholder="Enter Scheme Category"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField name="country" label="Country" placeholder="Enter Country" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="currency"
                        label="Currency"
                        items={Object.keys(CurrencyMaster).map((item) => ({
                          key: CurrencyMaster[item].currency,
                          value: item,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="transactionCurrency"
                        label="Transaction Currency"
                        items={Object.keys(CurrencyMaster).map((item) => ({
                          key: CurrencyMaster[item].currency,
                          value: item,
                        }))}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <DatePicker
                        label={'Scheme Start Date'}
                        inputLabelStyles={{
                          transform: 'unset',
                          fontSize: 14,
                          fontWeight: 500,

                          color: 'rgba(0,0,0,0.7)',
                        }}
                        placeholder={'Enter Scheme Start Date'}
                        name={`schemeStartDate`}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="lockInPeriod"
                        label="Lock In Period(In Year)"
                        placeholder="Enter Lock In Period(In Year)"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="lockInExtension"
                        label="Lock In Extension(In Year)"
                        placeholder="Enter Lock In Extension(In Year)"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="faceValue"
                        label="Face value"
                        placeholder="Enter Face value"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="fundAddress1"
                        label="Fund Address 1"
                        placeholder="Enter Fund Address 1"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="fundAddress2"
                        label="Fund Address 2"
                        placeholder="Enter Fund Address 2"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="fundAddress3"
                        label="Fund Address 3"
                        placeholder="Enter Fund Address 3"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="custodian"
                        label="Custodian"
                        placeholder="Enter Custodian"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="setupFee"
                        label="Setup Fee/Organizational Expenses"
                        placeholder="Enter Setup Fee/Organizational Expenses"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="minCommitmentAmount"
                        label="Minimum Commitment Amount *"
                        placeholder="Enter Minimum Commitment Amount"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                      {values.minCommitmentAmount != 0 && (
                        <Typography sx={{ fontSize: 13 }}>
                          {currencyConversion(values.minCommitmentAmount)}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="maxCommitmentAmount"
                        label="Maximum Commitment Amount *"
                        placeholder="Enter Maximum Commitment Amount"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                      {values.maxCommitmentAmount != 0 && (
                        <Typography sx={{ fontSize: 13 }}>
                          {currencyConversion(values.maxCommitmentAmount)}
                        </Typography>
                      )}
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="minContributionPercentage"
                        label="Minimum Contribution Percentage"
                        placeholder="Enter Minimum Contribution Percentage"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="operatingExpenses"
                        label="Operating Expenses"
                        placeholder="Enter Operating Expenses"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    <Grid sx={{ marginTop: '30px' }} item xs={12} sm={6} md={4}>
                      <MFCheckbox
                        name={`managementFeeCheck`}
                        label="Enable Management Fee(After Onboarding)"
                        sx={{ my: 1 }}
                        onChange={({ target: { checked } }) => {
                          setValues({
                            ...values,
                            managementFeeCheck: checked,
                          });
                        }}
                        checked={values.managementFeeCheck}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="managementFee"
                        label={`Management Fee ${
                          values.managementFeeCheck ? '(During Commitment Period)' : ''
                        }`}
                        placeholder={`Enter Management Fee ${
                          values.managementFeeCheck ? '(During Commitment Period)' : ''
                        }`}
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid>
                    {values.managementFeeCheck && (
                      <Grid item xs={12} sm={6} md={4}>
                        <MFTextField
                          name="managementFeeAfterCommitment"
                          label={`Management Fee (After Onboarding)`}
                          placeholder="Enter Management Fee (After the Commitment Period)"
                          type="number"
                          onKeyDown={(e) => {
                            allowOnlyNumbers(e);
                          }}
                          trimOnBlur={false}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={6} md={4}>
                      <UseRadioGroup
                        formLabel="Accredited Investor Applicable *"
                        name={`accreditedInvestorApplicable`}
                        items={Object.keys(yesNoMaster).map((item) => ({
                          label: yesNoMaster[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                    {isAccreditedInvestorApplicable(values.accreditedInvestorApplicable) && (
                      <Grid item xs={12} sm={6} md={4}>
                        <MFTextField
                          name="accreditedMinCommitmentAmount"
                          label="Accredited Minimum Commitment Amount *"
                          placeholder="Enter Accredited Minimum Commitment Amount"
                          type="number"
                          onKeyDown={(e) => {
                            allowOnlyNumbers(e);
                          }}
                          trimOnBlur={false}
                        />
                        {values.accreditedMinCommitmentAmount != 0 && (
                          <Typography sx={{ fontSize: 13 }}>
                            {currencyConversion(values.accreditedMinCommitmentAmount)}
                          </Typography>
                        )}
                      </Grid>
                    )}
                    {/* <Grid item xs={12} sm={6} md={4}>
                      <MFSelectField
                        name="hurdleRate"
                        label="Hurdle Rate"
                        items={hurdleRateMaster.map((item) => ({
                          key: item.displayText,
                          value: item.hurdleRate,
                        }))}
                        onChange={(e) => {
                          setValues({
                            ...values,
                            performanceFee:
                              hurdleRateMaster?.find((item) => item.hurdleRate === e.target.value)
                                ?.performanceFee || 0,
                            hurdleRate: (e.target.value as number) || 0,
                          });
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="performanceFee"
                        label="Performance Fee"
                        placeholder="Enter Performance Fee"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                        disabled={!Enable_Performance_Fee}
                      />
                    </Grid> */}
                    {/* <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="placementCost"
                        label="Placement Cost"
                        placeholder="Enter Placement Cost"
                        type="number"
                        onKeyDown={(e) => {
                          allowOnlyNumbers(e);
                        }}
                        trimOnBlur={false}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="tcLink"
                        label={`T&C Link`}
                        placeholder={`Enter T&C Link`}
                      />
                    </Grid>
                    {checkIfApplicable(values.excludeClauseApplicableInPlan) && (
                      <Grid item xs={12}>
                        <UseRadioGroup
                          formLabel="Excuse and Exclude Clause Undersigning *"
                          subLabel={excludeClauseSubLabel}
                          name={`excludeClause`}
                          items={Object.keys(EXCLUDE_CLAUSE_MASTER).map((clause) => ({
                            label: EXCLUDE_CLAUSE_MASTER[clause],
                            value: clause,
                          }))}
                        />
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      sx={{ '.MuiFormControl-root': { marginTop: '16px' } }}>
                      <UseRadioGroup
                        name={`exitChargeApplicable`}
                        formLabel={`Exit Charges Applicable *`}
                        items={Object.keys(yesNoMaster).map((item) => ({
                          label: yesNoMaster[item],
                          value: item,
                        }))}
                      />
                    </Grid>
                    {checkIfApplicable(values.exitChargeApplicable) && (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={4}
                        sx={{ pl: { xs: 0, sm: '28px' }, mt: { xs: 2, sm: 0 } }}>
                        <Typography
                          sx={{
                            fontFamily: 'Work Sans,sans-serif',
                            fontWeight: 400,
                            fontSize: '15px',
                          }}
                          component="span">
                          Exit Charge *
                        </Typography>
                        <MFTextField
                          name="exitCharge"
                          multiline
                          rows={4.5}
                          // label={`Exit Load`}
                          placeholder={`Enter Exit Charge`}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} sm={12} md={12}>
                      <DataTable
                        tableData={values.hurdlerates.filter((obj) => obj.isActive)}
                        tableHeader={[...columns, ...AccessViewOrEditCell]}
                        noOfPages={1}
                        renderAdditionalRow={true}
                        tableBodyCustomStyles={{
                          '.MuiTableCell-root': {
                            borderBottom: 'none',
                          },
                        }}
                        tableHeaderCustomStyles={{
                          '.MuiTableCell-head': {
                            fontFamily: 'Poppins, sans-serif',
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'primary.main',
                            textAlign: 'left',
                            pl: 2,
                            '&:nth-of-type(1)': {
                              pl: 6,
                            },
                          },
                        }}
                        rowCustomStyles={{
                          '.MuiTableCell-root': {
                            py: 0,
                            overflowWrap: 'anywhere',
                            textAlign: 'left',
                            verticalAlign: 'top',
                          },
                        }}
                        boxStyles={{ minHeight: '0px', minWidth: 450, maxHeight: 'unset' }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        startIcon={<AddIcon />}
                        sx={{
                          color: 'primary.main',
                          fontWeight: 500,
                          fontSize: 14,
                          mt: 2,
                        }}
                        onClick={() =>
                          setValues({
                            ...values,
                            hurdlerates: [
                              ...values.hurdlerates,
                              { ...newHurdleRate, sno: values.hurdlerates.length },
                            ],
                          })
                        }>
                        Add Hurdle Rate
                      </Button>
                    </Grid>
                    <ConfirmationDialog
                      message={'Are you sure you want to delete hurdleRate ?'}
                      open={hurdleRateToDelete !== null}
                      setOpen={() => {
                        setHurdleRateToDelete(null);
                      }}
                      onSave={() => {
                        const remainedHurdleRates = values.hurdlerates.map((obj) => {
                          if (obj.sno === hurdleRateToDelete?.index) {
                            return {
                              ...obj,
                              isActive: false,
                            };
                          }
                          return obj;
                        });
                        setValues({
                          ...values,
                          hurdlerates: remainedHurdleRates,
                        });
                        setHurdleRateToDelete(null);
                      }}
                      onCancel={() => {
                        setHurdleRateToDelete(null);
                      }}
                    />
                    {/* empty grid for proper alignment */}
                    <Grid xs={12}></Grid>
                    <Grid item xs={12} sm={6} sx={{ mt: 2 }}>
                      <Box sx={{ display: 'flex' }}>
                        <MFCheckbox name={`isApplicableForDirect`} label="Direct" />
                        <MFCheckbox
                          name={`isApplicableForDistributor`}
                          label="Distributor"
                          onChange={({ target: { checked } }) => {
                            setValues({
                              ...values,
                              isApplicableForDistributor: checked,
                              distributorIds: [],
                            });
                          }}
                          checked={values.isApplicableForDistributor}
                        />
                      </Box>
                      {values.isApplicableForDistributor && (
                        <MultipleSelect
                          name="distributorIds"
                          label="Applicable Distributor(s) *"
                          items={distributorList.map((item) => ({
                            key: item.id,
                            value: `${item.arnCode || 'N/A'} - ${item.name} (${item.type})`,
                          }))}
                          renderText="Selected Distributor(s)"
                        />
                      )}
                    </Grid>
                  </Grid>
                )}
                {values?.isApplicableForDistributor && (
                  <Grid container rowSpacing={1} columnSpacing={4} px={2}>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="distMangementFee"
                        label=" Distribution/ Placement Fees *"
                        placeholder="Enter  Distribution/ Placement Fees"
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                      <MFTextField
                        name="distPerformanceFee"
                        label="Distribution Commission: Performance Fees *"
                        placeholder="Enter Distribution Commission: Performance Fees"
                      />
                    </Grid>
                  </Grid>
                )}
                {access && (
                  <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 3 }}>
                    <MFSubmitButton label="Save" />
                  </Box>
                )}
              </>
            )}
          </Box>
        )}
      </Formik>
    </>
  );
}
